<template>
  <div>
    <div class="dialog-add-account__form-title">
      {{ $t('business_account_data.contact_name') }}
    </div>

    <div class="dialog-add-account__form-block">
      <div class="dialog-add-account__form-row">
        <div class="dialog-add-account__form-col">
          <div class="dialog-add-account__form-item">
            <div
              class="form-input"
              :class="[
                { 'form-input--full': value.name },
                {
                  'form-input--error':
                    errors.name || (serverErrors && serverErrors.legal_contact_name),
                },
              ]"
            >
              <input
                :value="value.name"
                type="text"
                required
                :disabled="disabled"
                @input="$emit('update:name', $event.target.value)"
              />
              <span class="form-input__label">{{ $t('business_account_data.name') }}</span>
              <div v-if="errors.name" class="form-input__error" v-text="errors.name" />
              <div v-if="serverErrors && serverErrors.legal_contact_name" class="form-input__error">
                <p v-for="(err, index) in serverErrors.legal_contact_name" :key="index">
                  {{ err }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="dialog-add-account__form-col">
          <div class="dialog-add-account__form-item">
            <div
              class="form-input"
              :class="[
                { 'form-input--full': value.phone },
                { 'form-input--error': errors.phone || (serverErrors && serverErrors.phone) },
              ]"
            >
              <input
                :value="value.phone"
                type="tel"
                required
                :disabled="disabled"
                @input="$emit('update:phone', $event.target.value)"
              />
              <span class="form-input__label">{{ $t('business_account_data.phone') }}</span>
              <div v-if="errors.phone" class="form-input__error" v-text="errors.phone" />
              <div v-if="serverErrors && serverErrors.phone" class="form-input__error">
                <p v-for="(err, index) in serverErrors.phone" :key="index">
                  {{ err }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="dialog-add-account__form-col">
          <div class="dialog-add-account__form-item">
            <div
              class="form-input"
              :class="[
                { 'form-input--full': value.email },
                { 'form-input--error': errors.email || (serverErrors && serverErrors.email) },
              ]"
            >
              <input
                :value="value.email"
                type="text"
                required
                :disabled="disabled"
                @input="$emit('update:email', $event.target.value)"
              />
              <span class="form-input__label">{{ $t('business_account_data.email') }}</span>
              <div v-if="errors.email" class="form-input__error" v-text="errors.email" />
              <div v-if="serverErrors && serverErrors.email" class="form-input__error">
                <p v-for="(err, index) in serverErrors.email" :key="index">
                  {{ err }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactPersonForm',
  props: {
    value: {
      type: Object,
      required: true,
      validator: (value) => {
        return 'name' in value && 'phone' in value && 'email' in value;
      },
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    serverErrors: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:name', 'update:phone', 'update:email'],
};
</script>
